import { useState, useEffect, useCallback } from "react";
import api from "../utils/api";
import toast from "react-hot-toast";

export function useFuelLogs() {
  const [logs,    setLogs]    = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/fuel-logs");
      setLogs(data);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load fuel logs");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  async function addLog(payload) {
    const { data } = await api.post("/api/fuel-logs", payload);
    setLogs(prev => [data, ...prev]);
    return data;
  }

  async function removeLog(id) {
    await api.delete(`/api/fuel-logs/${id}`);
    setLogs(prev => prev.filter(l => l.id !== id));
  }

  return { logs, loading, addLog, removeLog, reload: load };
}
